import * as types from '../constants/actionTypes';
import { CALL_API } from '../helpers/api';

export const actions = {
    checkUserRequestAccessCode: (accessCode) => {
        return (dispatch) => {
            const body = {
                accessCode: accessCode
            };

            return dispatch({
                [CALL_API]: {
                    endpoint: 'user-access-request/check-access-code',
                    method: 'POST',
                    body: body,
                    types: [
                        types.CHECK_ACCESS_CODE_REQUEST,
                        types.CHECK_ACCESS_CODE_SUCCESS,
                        types.CHECK_ACCESS_CODE_FAILURE
                    ]
                }
            });
        }
    },
    checkAddSubscriptionAccessCode: (accessCode) => {
        return (dispatch) => {
            return dispatch({
                [CALL_API]: {
                    endpoint: 'user-access-request/check-add-sub-access-code',
                    method: 'POST',
                    body: { accessCode: accessCode },
                    types: [
                        types.CHECK_ADD_SUB_ACCESS_CODE_REQUEST,
                        types.CHECK_ADD_SUB_ACCESS_CODE_SUCCESS,
                        types.CHECK_ADD_SUB_ACCESS_CODE_FAILURE
                    ]
                }
            });
        }
    },    
    checkUserRequestUserName: (subId, userName, email) => {
        return (dispatch) => {
            const body = {
                userName: userName,
                email: email,
                subscriptionId: subId
            };

            return dispatch({
                [CALL_API]: {
                    endpoint: 'user-access-request/check-user-name',
                    method: 'POST',
                    body: body,
                    types: [
                        types.CHECK_USER_NAME_REQUEST,
                        types.CHECK_USER_NAME_SUCCESS,
                        types.CHECK_USER_NAME_FAILURE
                    ]
                }
            });
        }
    },
    loadUserAccessRequestProfileFilters: (subscriptionId) => {
        return (dispatch) => {
            const body = {
                subscriptionId: subscriptionId
            };

            return dispatch({
                [CALL_API]: {
                    endpoint: 'user-access-request/profile-filters',
                    method: 'POST',
                    body: body,
                    types: [
                        types.LOAD_USER_REQUEST_PROFILE_FILTERS_REQUEST,
                        types.LOAD_USER_REQUEST_PROFILE_FILTERS_SUCCESS,
                        types.LOAD_USER_REQUEST_PROFILE_FILTERS_FAILURE
                    ]
                }
            });
        }
    },
    createUserAccessRequest: (userRequest) => {
        return (dispatch) => {
            const body = { ...userRequest };

            return dispatch({
                [CALL_API]: {
                    endpoint: 'user-access-request/create',
                    method: 'POST',
                    body: body,
                    types: [
                        types.CREATE_USER_ACCESS_REQUEST_REQUEST,
                        types.CREATE_USER_ACCESS_REQUEST_SUCCESS,
                        types.CREATE_USER_ACCESS_REQUEST_FAILURE
                    ]
                }
            });
        }
    },
    createAddSubscriptionRequest: (userRequest) => {
        return (dispatch) => {
            const body = { ...userRequest };

            return dispatch({
                [CALL_API]: {
                    endpoint: 'user-access-request/add-subscription-request',
                    method: 'POST',
                    body: body,
                    types: [
                        types.CREATE_ADD_SUBSCRIPTION_REQUEST_REQUEST,
                        types.CREATE_ADD_SUBSCRIPTION_REQUEST_SUCCESS,
                        types.CREATE_ADD_SUBSCRIPTION_REQUEST_FAILURE
                    ]
                }
            });
        }
    },
    loadListFilters: (subscriptionId) => {
        return (dispatch) => {
            const body = { 
                subscriptionId: subscriptionId 
            };

            return dispatch({
                [CALL_API]: {
                    endpoint: 'user-access-request/list-filters',
                    method: 'POST',
                    body: body,
                    types: [
                        types.LOAD_USER_ACCESS_REQUEST_LIST_FILTERS_REQUEST,
                        types.LOAD_USER_ACCESS_REQUEST_LIST_FILTERS_SUCCESS,
                        types.LOAD_USER_ACCESS_REQUEST_LIST_FILTERS_FAILURE
                    ]
                }
            });
        }
    },
    search: (request) => {
        return (dispatch) => {
            return dispatch({
                [CALL_API]: {
                    endpoint: 'user-access-request/search',
                    method: 'POST',
                    body: request,
                    types: [
                        types.SEARCH_USER_ACCESS_REQUEST_REQUEST,
                        types.SEARCH_USER_ACCESS_REQUEST_SUCCESS,
                        types.SEARCH_USER_ACCESS_REQUEST_FAILURE
                    ]
                }
            });
        }
    },
    update: (userRequest) => {
        return (dispatch) => {
            return dispatch({
                [CALL_API]: {
                    endpoint: 'user-access-request/update',
                    method: 'POST',
                    body: userRequest,
                    types: [
                        types.UPDATE_USER_ACCESS_REQUEST_REQUEST,
                        types.UPDATE_USER_ACCESS_REQUEST_SUCCESS,
                        types.UPDATE_USER_ACCESS_REQUEST_FAILURE
                    ]
                }
            });
        }
    },
    loadUpdateFilters: (subscriptionId) => {
        return (dispatch) => {
            const body = {
                subscriptionId: subscriptionId
            };

            return dispatch({
                [CALL_API]: {
                    endpoint: 'user-access-request/update-filters',
                    method: 'POST',
                    body: body,
                    types: [
                        types.LOAD_USER_REQUEST_UPDATE_FILTERS_REQUEST,
                        types.LOAD_USER_REQUEST_UPDATE_FILTERS_SUCCESS,
                        types.LOAD_USER_REQUEST_UPDATE_FILTERS_FAILURE
                    ]
                }
            });
        }
    },
    loadUserAccessRequest: (userAccessRequestId) => {
        return (dispatch) => {
            return dispatch({
                [CALL_API]: {
                    endpoint: 'user-access-request/' + userAccessRequestId,
                    method: 'GET',
                    types: [
                        types.LOAD_USER_ACCESS_REQUEST_REQUEST,
                        types.LOAD_USER_ACCESS_REQUEST_SUCCESS,
                        types.LOAD_USER_ACCESS_REQUEST_FAILURE
                    ]
                }
            });
        }
    },
    deny: (id, subscriptionId) => {
        return (dispatch) => {
            const body = {
                id: id,
                subscriptionId: subscriptionId
            };

            return dispatch({
                [CALL_API]: {
                    endpoint: 'user-access-request/deny',
                    method: 'POST',
                    body: body,
                    types: [
                        types.DENY_USER_ACCESS_REQUEST_REQUEST,
                        types.DENY_USER_ACCESS_REQUEST_SUCCESS,
                        types.DENY_USER_ACCESS_REQUEST_FAILURE
                    ]
                }
            });
        }
    },
    approve: (userRequest) => {
        return (dispatch) => {
            return dispatch({
                [CALL_API]: {
                    endpoint: 'user-access-request/approve',
                    method: 'POST',
                    body: userRequest,
                    types: [
                        types.APPROVE_USER_ACCESS_REQUEST_REQUEST,
                        types.APPROVE_USER_ACCESS_REQUEST_SUCCESS,
                        types.APPROVE_USER_ACCESS_REQUEST_FAILURE
                    ]
                }
            });
        }
    }
}
